import {
  Flex,
  IconButton,
  Image,
  Link,
  useDisclosure,
  Drawer,
  DrawerContent,
  Box,
  useBreakpointValue,
} from "@chakra-ui/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars, faClose } from "@fortawesome/free-solid-svg-icons";
import { options } from "../../models/Home";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useMediaQuery } from "react-responsive";
import HeaderOption from "./HeaderOption";
import HeaderMenu from "./HeaderMenu";
import HeaderMenuContent from "./HeaderMenuContent";
import useAuthUser from "react-auth-kit/hooks/useAuthUser";
import { useCompany } from "../../contexts/CompanyContext";
import { BsFillXCircleFill } from "react-icons/bs";
import { hasScreenAccess } from "../../utils/screens";
import NotificationBell from "../NotificationBell";

const Header = ({ isHome = false }: { isHome?: boolean }) => {
  const isMobile = useMediaQuery({ query: "(max-width: 768px)" });
  const auth = useAuthUser<any>();
  const { isOpen, onOpen, onClose } = useDisclosure();

  // Filter options based on user permissions
  const filteredOptions = options
    .filter((o) =>
      auth?.position === 0 || auth?.position === 1
        ? ["/dashboard", "/documents", "/processes", "/financial"].includes(
            o.link,
          )
        : auth?.position > 1 ||
        (o.link !== "/processes-status" &&
          o.link !== "/purchaseOrders" &&
          o.link !== "/commercial")
    )
    .filter((o) => hasScreenAccess(auth, o.link));

  return !auth ? (
    <Box></Box>
  ) : (
    <Flex
      padding={{ base: "12px", md: "16px" }}
      height={{ base: "60px", sm: "65px", md: "70px" }}
    >
      {isMobile ? (
        <Flex justifyContent="space-between" w="100%" alignItems="center">
          <Link href="/" mb={{ base: "0px", md: "32px" }}>
            <Image
              src={
                process.env.REACT_APP_LOGO === "syntra"
                  ? "syntraLogo.png"
                  : "grupoCvfLogo.png"
              }
              height="40px"
              marginRight={{ base: "0px", md: "100px" }}
            />
          </Link>
          <Drawer
            autoFocus={false}
            isOpen={isOpen}
            placement="left"
            onClose={onClose}
            returnFocusOnClose={false}
            onOverlayClick={onClose}
            size="full"
          >
            <DrawerContent
              borderBottomWidth="1px"
              borderBottomColor="whitesmoke"
            >
              <Flex
                justifyContent="space-between"
                padding="16px"
                alignItems="center"
              >
                <Link href="/" mb={{ base: "16px", md: "32px" }}>
                  <Image
                    src={
                      process.env.REACT_APP_LOGO === "syntra"
                        ? "syntraLogo.png"
                        : "grupoCvfLogo.png"
                    }
                    height="40px"
                    marginRight={{ base: "50px", md: "100px" }}
                  />
                </Link>
                <Box fontSize={{ base: "24px", md: "32px" }}>
                  <BsFillXCircleFill
                    color="var(--icon-color)"
                    size="20px"
                    onClick={() => onClose()}
                  ></BsFillXCircleFill>
                </Box>
              </Flex>
              <Flex alignItems="center" flexDirection="column">
                {filteredOptions.map((o) => (
                  <HeaderOption
                    key={o.title}
                    style={{
                      maxHeight: { base: "50px", md: "60px" },
                      width: "100%",
                      borderBottomWidth: "1px",
                      borderBottomColor: "whitesmoke",
                    }}
                    o={o}
                  />
                ))}
                <Box
                  width="90%"
                  marginY={{ base: "16px", md: "32px" }}
                  borderTopColor="gray"
                  borderTopWidth="1px"
                ></Box>
                <HeaderMenuContent gap="8px" />
              </Flex>
            </DrawerContent>
          </Drawer>

          <Flex alignItems="center" gap="8px">
            <NotificationBell />
            <IconButton
              variant="outline"
              onClick={onOpen}
              aria-label="open menu"
              icon={<FontAwesomeIcon style={{ top: "3px" }} icon={faBars} />}
            />
          </Flex>
        </Flex>
      ) : (
        <>
          <Flex w="100%" alignItems="center">
            <Link href="/">
              <Image
                src={
                  process.env.REACT_APP_LOGO === "syntra"
                    ? "syntraLogo.png"
                    : "grupoCvfLogo.png"
                }
                height="40px"
                marginRight="50px"
              />
            </Link>
          </Flex>
          <Flex gap={{ base: "32px", md: "64px" }}>
            <HeaderMenu />
          </Flex>
        </>
      )}
    </Flex>
  );
};

export default Header;
